if (!customElements.get('gwt-recently-viewed')) {
  class GWTRecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.fetchAttempts = 0;

      if (window.initLazyScript) {
        window.initLazyScript(this, this.init.bind(this), 500);
      } else {
        this.init();
      }
    }

    async init() {
      const productIds = this.getProductIds();

      if (!productIds.length) {
        this.renderEmptyState();
        return;
      }

      this.setAttribute('aria-busy', 'true');

      try {
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));

        const response = await fetch(url.toString());
        if (!response.ok) throw new Error(response.status);

        const template = document.createElement('template');
        template.innerHTML = await response.text();

        const renderedSection = template.content.querySelector('gwt-recently-viewed');
        if (renderedSection?.hasChildNodes()) {
          this.innerHTML = renderedSection.innerHTML;
        } else {
          this.renderEmptyState();
        }
      } catch (error) {
        this.fetchAttempts += 1;

        if (this.fetchAttempts < 3) {
          await this.init();
        } else {
          this.renderEmptyState();
          console.log(error); // eslint-disable-line no-console
        }
      } finally {
        this.removeAttribute('aria-busy');
      }
    }

    getProductIds() {
      try {
        const storedIds = JSON.parse(localStorage.getItem('cc-recently-viewed') || '[]');
        if (!Array.isArray(storedIds)) return [];

        const excludeId = Number(this.dataset.exclude);
        const limit = Number(this.dataset.limit) || 8;

        return storedIds
          .map(Number)
          .filter((id) => Number.isInteger(id) && id > 0 && id !== excludeId)
          .slice(0, limit);
      } catch (error) {
        return [];
      }
    }

    renderEmptyState() {
      const message = document.createElement('p');
      message.className = 'gwt-explore-more__empty text-center';
      message.textContent = this.dataset.emptyMessage || '';
      this.replaceChildren(message);
    }
  }

  customElements.define('gwt-recently-viewed', GWTRecentlyViewed);
}
